import { Tprovinsi, initialProvinsi } from "./provinsi";

export interface Tcity {
    id: number;
    cityCode: string;
    cityName: string;
    cityType: number;
    provinsi: Tprovinsi;
}

export const initialCity: Tcity = {
    id: 0,
    cityCode: "",
    cityName: "",
    cityType: 0,
    provinsi: initialProvinsi
}